import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/site";
import { Seo } from "@/components/common";
import { RefreshCw } from "lucide-react";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/leads`);
      setLeads(r.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <main className="pt-28 pb-16 px-6 md:px-12 max-w-7xl mx-auto" data-testid="admin-leads-page">
      <Seo title="Lead Yönetimi" />
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-heading text-3xl font-semibold text-[#F2F5F7] tracking-tight">Lead Yönetimi</h1>
        <button onClick={load} data-testid="admin-refresh-btn" className="inline-flex items-center gap-2 rounded-[10px] border border-white/15 px-4 py-2 text-sm font-semibold hover:border-[var(--accent)] transition-colors">
          <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Yenile
        </button>
      </div>

      <div className="rounded-xl glass-card overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-leads-table">
          <thead>
            <tr className="border-b border-white/10 text-left text-xs uppercase tracking-wide text-[#7C8B97]">
              <th className="px-5 py-4">Tarih</th>
              <th className="px-5 py-4">Ad</th>
              <th className="px-5 py-4">E-posta / Telefon</th>
              <th className="px-5 py-4">Kaynak</th>
              <th className="px-5 py-4">Ülke</th>
              <th className="px-5 py-4">Zamanlama</th>
              <th className="px-5 py-4">İletişim tercihi</th>
              <th className="px-5 py-4">Konular</th>
              <th className="px-5 py-4">Dosya</th>
            </tr>
          </thead>
          <tbody>
            {leads.length === 0 && !loading && (
              <tr>
                <td colSpan={9} className="px-5 py-10 text-center text-[#7C8B97]" data-testid="admin-empty-state">Henüz lead yok</td>
              </tr>
            )}
            {leads.map((l) => (
              <tr key={l.id} className="border-b border-white/5 hover:bg-white/5" data-testid="admin-lead-row">
                <td className="px-5 py-4 whitespace-nowrap text-[#94A3AE]">{new Date(l.created_at).toLocaleString("tr-TR")}</td>
                <td className="px-5 py-4 font-semibold text-[#F2F5F7]">{l.name}</td>
                <td className="px-5 py-4 text-[#94A3AE]">
                  {l.email}
                  {l.phone && <div className="text-xs">{l.phone}</div>}
                </td>
                <td className="px-5 py-4">
                  <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${l.source === "mirror" ? "bg-[var(--accent-soft)] text-[var(--accent)]" : "bg-white/10 text-[#94A3AE]"}`}>{l.source}</span>
                </td>
                <td className="px-5 py-4 text-[#94A3AE]">{l.country || "—"}</td>
                <td className="px-5 py-4 text-[#94A3AE]">{l.timeline || "—"}</td>
                <td className="px-5 py-4 text-[#94A3AE]">{l.contact_preference || "—"}</td>
                <td className="px-5 py-4 text-[#94A3AE]">{(l.topics || []).join(", ") || "—"}</td>
                <td className="px-5 py-4 text-[#94A3AE]">{(l.file_ids || []).length}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </main>
  );
}
